export const environment = {
  name: 'qual',
  production: true,
  urlSite: 'https://qual-cros.bizzdev.net/',

  apiUrl: 'https://qual-cros.bizzdev.net/api',

  apiDomain: 'https://qual-cros.bizzdev.net/',
  identityApiUrl: 'https://qual-cros.bizzdev.net/identity/',
  whiteListedUrl: 'https://qual-cros.bizzdev.net/api',
  socialBlackListedUrl: 'https://qual-cros.bizzdev.net/api/user/socials/login',
  blacklistedUrl: 'https://qual-cros.bizzdev.net/',

  tokenKey: 'bizz-qual-cros-token-admin',
  tokenExpKey: 'bizz-qual-cros-token-exp-admin',
  rfTokenKey: 'bizz-qual-cros-rf-token-admin',

  // idFacebook: '393729041973071', ancien
  idFacebook: '490907449311075',
  // idGoogle: '237306086532-j8j8t492na2dal89argf5dblpc8c95r7.apps.googleusercontent.com', ancien
  idGoogle: '200885114390-4ofn46hboqoij2mbh58jeq1e51tnu7id.apps.googleusercontent.com',
  idSystempay:
    '87116628:testpublickey_RpnPCXo8p5bf4pKIfmqHAI7KQCgIr1Ytw1pWny0crIiG0',
  // idSystempay: '87116628:publickey_Wf1yEQyAxhL0p1gkbgh8ENhu59NAVP9Qz81xvDcJdQDvz',
  version: require('../../package.json').version
};


// export const environment = {
//   name: 'qual',
//   production: true,
//   urlSite: 'https://qual-lvhdf.bizzdev.net/',

//   apiUrl: 'https://qual-lvhdf.bizzdev.net/api',

//   apiDomain: 'https://qual-lvhdf.bizzdev.net/',
//   identityApiUrl: 'https://qual-lvhdf.bizzdev.net/identity/',
//   whiteListedUrl: 'https://qual-lvhdf.bizzdev.net/api',
//   socialBlackListedUrl: 'https://qual-lvhdf.bizzdev.net/api/user/socials/login',
//   blacklistedUrl: 'https://qual-lvhdf.bizzdev.net/',

//   tokenKey: 'bizz-ffv-token-admin',
//   tokenExpKey: 'bizz-ffv-token-exp-admin',
//   rfTokenKey: 'bizz-ffv-rf-token-admin',

//   // idFacebook: '393729041973071', ancien
//   idFacebook: '490907449311075',
//   // idGoogle: '237306086532-j8j8t492na2dal89argf5dblpc8c95r7.apps.googleusercontent.com', ancien
//   idGoogle: '200885114390-4ofn46hboqoij2mbh58jeq1e51tnu7id.apps.googleusercontent.com',
//   idSystempay:
//     '87116628:testpublickey_RpnPCXo8p5bf4pKIfmqHAI7KQCgIr1Ytw1pWny0crIiG0',
//   // idSystempay: '87116628:publickey_Wf1yEQyAxhL0p1gkbgh8ENhu59NAVP9Qz81xvDcJdQDvz',
//   version: require('../../package.json').version
// };
